<template>
    <div class="canvas-section" :class="{locked}">
        <div class="head" :class="headClass" :style="{backgroundColor: headBg}">
            <h4 class="title mb-0">
                <slot name="title"></slot>
            </h4>
            <div class="actions ml-auto">
                <slot name="actions"></slot>
            </div>
        </div>
        <div class="content">
            <slot></slot>
        </div>
        <div v-if="locked" class="locked-info">
            <img src="/images/icons/lock.svg" class="lock" alt="">
            <div>
                You must complete all the previous stage(s) to open this stage.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CanvasSection",
    props: {
        headClass: {
            type: String,
            default: 'text-light',
        },
        headBg: {
            type: String,
            default: '#333333',
        },
        locked: false,
    }
}
</script>

<style lang="scss" scoped>
// .canvas-section{
//     //padding-top: 10.5rem;
//     //margin-top: -10.5rem;
// }
.head{
    display: flex;
    align-items: center;
    margin-left: -0.8rem;
    padding: 1rem 1.5rem 1rem 2.3rem;
    border-radius: 12px 0 0 12px;

    @media (max-width: 768px) {
        margin-left: -0.2rem;
    }
}

.locked{
    position: relative;

    &:before{
        content: '';
        background: rgba(white, 0);
        cursor: not-allowed;
        position: absolute;
        top: 10.5rem;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 10;
    }

    > * {
        opacity: 0.1;
    }
}


.locked-info{
    position: absolute;
    z-index: 11;
    opacity: 1;
    background: darken($light, 3%);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 5.25rem;
    text-align: center;
    padding: 2rem;
    border-radius: 1rem;
    box-shadow: rgba(black, 0.1) 0 3px 5px;

    img{
        width: 6rem;
        height: auto;
    }
}
</style>
